module.exports = __webpack_public_path__ + "static/media/(V)_MG_5610_-_Cia_Termal_Beachewear_-_Moda_Masculina_-_Moda_Masculina_Infantil.e85c57e8.jpg";